
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface BallAnalyticsTabProps {
  data: {
    trajectory: {
      possessionTime: {
        team1: string;
        team2: string;
      };
      speedData: {
        average: number;
        max: number;
        passCounts: {
          short: number;
          medium: number;
          long: number;
        };
      };
    };
    events: {
      goals: Array<{
        timestamp: string;
        player: number;
        team: string;
      }>;
      crosses: number;
      corners: number;
      freeKicks: number;
    };
  };
}

const BallAnalyticsTab: React.FC<BallAnalyticsTabProps> = ({ data }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Ball Trajectory</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Possession:</span>
              <div className="mt-1 grid grid-cols-2 gap-2 text-sm">
                <div className="bg-blue-50 p-2 rounded">
                  Team 1: {data.trajectory.possessionTime.team1}
                </div>
                <div className="bg-red-50 p-2 rounded">
                  Team 2: {data.trajectory.possessionTime.team2}
                </div>
              </div>
            </div>
            <Separator />
            <div>
              <span className="font-medium">Ball Speed:</span>
              <div className="mt-1 space-y-1 text-sm">
                <p>Average: {data.trajectory.speedData.average} km/h</p>
                <p>Maximum: {data.trajectory.speedData.max} km/h</p>
              </div>
            </div>
            <Separator />
            <div>
              <span className="font-medium">Pass Distribution:</span>
              <div className="mt-1 space-y-1 text-sm">
                <p>Short Passes: {data.trajectory.speedData.passCounts.short}</p>
                <p>Medium Passes: {data.trajectory.speedData.passCounts.medium}</p>
                <p>Long Passes: {data.trajectory.speedData.passCounts.long}</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Ball Events</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Goals:</span>
              <ul className="mt-1 space-y-1 text-sm">
                {data.events.goals.map((goal, index) => (
                  <li key={index}>
                    {goal.timestamp} - Player {goal.player}, {goal.team}
                  </li>
                ))}
              </ul>
            </div>
            <Separator />
            <div>
              <span className="font-medium">Set Piece Events:</span>
              <div className="mt-1 grid grid-cols-3 gap-2 text-sm">
                <div className="bg-gray-50 p-2 rounded text-center">
                  <p className="font-medium">Crosses</p>
                  <p className="text-lg">{data.events.crosses}</p>
                </div>
                <div className="bg-gray-50 p-2 rounded text-center">
                  <p className="font-medium">Corners</p>
                  <p className="text-lg">{data.events.corners}</p>
                </div>
                <div className="bg-gray-50 p-2 rounded text-center">
                  <p className="font-medium">Free Kicks</p>
                  <p className="text-lg">{data.events.freeKicks}</p>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BallAnalyticsTab;
